export const daysDisplay = (days: number) => {
  if (days === 0) {
    return "< 1 day";
  }
  if (days === 1) {
    return "1 day";
  }
  return `${days} days`;
};
